
import React from 'react';
import { ArrowRightIcon } from './icons';

interface SamplePromptCardProps {
  title: string;
  prompt: string;
  onClick: (prompt: string) => void;
}

export const SamplePromptCard: React.FC<SamplePromptCardProps> = ({ title, prompt, onClick }) => {
  return (
    <div 
      className="flex flex-col justify-between items-start self-stretch p-3 sm:p-4 w-full rounded-xl bg-primary-100/30 cursor-pointer hover:bg-primary-200/50 transition-colors min-w-0"
      onClick={() => onClick(prompt)}
    >
      <div className="flex flex-col items-start gap-2 sm:gap-3 self-stretch min-w-0">
        <div className="self-stretch text-primary-700 font-grotesk font-bold leading-none break-words" style={{ fontSize: '12px' }}>{title}</div>
        <div className="self-stretch text-grayscale-1100 font-grotesk leading-snug break-words" style={{ fontSize: '14px' }}>{prompt}</div>
      </div>
      <div className="flex justify-between items-center self-stretch mt-2 sm:mt-3 gap-2 min-w-0">
        <div className="text-grayscale-600 font-grotesk font-light leading-none flex-1 min-w-0 break-words" style={{ fontSize: '13px' }}>Click and try a sample</div>
        <div className="flex p-1.5 sm:p-2 justify-center items-center gap-2 rounded-xl border border-primary-200 flex-shrink-0">
          <ArrowRightIcon />
        </div>
      </div>
    </div>
  );
};